export enum PriceMetadataType {
  PLAN = 'plan',
  ADDITIONAL_MEMBER = 'additionalMember',
}
